import React, { useEffect } from "react"
import styled from "styled-components"
import { useFormContext } from "react-hook-form"
import InputNumber from "@src/components/reusable/forms/input-number"
import { slugify } from "@src/utils/slugify"

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.gray200};
  padding-bottom: 40px;
  padding-top: 40px;

  @media (max-width: 660px) {
    flex-direction: column;
    gap: 24px;
  }
`

const Title = styled.div`
  color: ${props => props.theme.gray900};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  @media (max-width: 500px) {
    font-size: 18px;
    line-height: 24px;
  }
`

const Row = styled.div`
  width: 100%;
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(2, 1fr);
  .input-number {
    width: 100%;
    & > div {
      padding: 4px 0px;
      width: calc(100% - 2px);
    }
  }
  @media (max-width: 660px) {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    gap: 24px;
  }
`

const Column = styled.div`
  width: 69%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 660px) {
    width: 100%;
    gap: 24px;
  }
`

const Result = styled.div`
  border-radius: 8px;
  background: ${props => props.theme.secondary50};
  color: ${props => props.theme.secondary600};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  text-wrap: nowrap;
  gap: 8px;
  width: max-content;
`

const OptionsRoomSelection = ({ rooms, setRooms, roomTypes }) => {
  // const [passengers, setPassengers] = useState(0)
  const { watch } = useFormContext()

  const roomFieldNames = roomTypes.map(type => `rooms.${slugify(type)}`)

  const roomValues = watch(roomFieldNames)
  useEffect(() => {
    const total = roomValues?.reduce(
      (sum, val) => sum + (parseInt(val) || 0),
      0,
    )
    setRooms(total)
  }, [roomValues, setRooms])

  // Split into rows of two
  const rows = []
  for (let i = 0; i < roomTypes.length; i += 2) {
    rows.push(roomTypes.slice(i, i + 2))
  }
  return (
    <Wrapper>
      <Title>Room Selection</Title>
      <Column>
        {rows.map((row, rowIndex) => (
          <Row key={rowIndex}>
            {row.map((type, index) => (
              <InputNumber
                key={`${rowIndex}-${index}`}
                label={type}
                name={`rooms.${slugify(type)}`}
                min={0}
                max={100}
                required={false}
                defaultValue={0}
              />
            ))}
          </Row>
        ))}
        <Row>
          <Result>
            <Group /> {rooms} rooms {/* / {passengers} passengers */}
          </Result>
        </Row>
      </Column>
    </Wrapper>
  )
}

export default OptionsRoomSelection

const Group = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M19.1668 9.16601H17.5001V7.49933C17.5001 7.0391 17.127 6.66602 16.6668 6.66602C16.2066 6.66602 15.8335 7.0391 15.8335 7.49933V9.16601H14.1668C13.7066 9.16601 13.3335 9.5391 13.3335 9.99933C13.3335 10.4596 13.7066 10.8326 14.1668 10.8326H15.8335V12.4993C15.8335 12.9596 16.2066 13.3326 16.6668 13.3326C17.127 13.3326 17.5001 12.9596 17.5001 12.4993V10.8326H19.1668C19.627 10.8326 20.0001 10.4596 20.0001 9.99933C20.0001 9.5391 19.627 9.16601 19.1668 9.16601Z"
        fill="#374957"
      />
      <path
        d="M7.5 10C10.2614 10 12.5 7.76142 12.5 5C12.5 2.23858 10.2614 0 7.5 0C4.73858 0 2.5 2.23858 2.5 5C2.5 7.76142 4.73858 10 7.5 10Z"
        fill="#374957"
      />
      <path
        d="M7.5 11.6659C3.35977 11.6705 0.00460937 15.0257 0 19.1659C0 19.6261 0.373086 19.9992 0.83332 19.9992H14.1666C14.6269 19.9992 15 19.6261 15 19.1659C14.9954 15.0257 11.6402 11.6705 7.5 11.6659Z"
        fill="#374957"
      />
    </svg>
  )
}
